export default __webpack_public_path__ + "static/media/bass chordys.ff70fb0e.wav";